import React from "react";
import PT from "prop-types";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import nlSenaLogo from "../../../../assets/images/nl-images/NLSenaPage-image-on-topleft.png";
import { NLFundProjectCard } from "./nl-fund-project-card";
import CommonStoryCard from "../../molecules/common-story-card";
import getStoriesByCollection from "../../../utils";
import Loader from "../../atoms/loader";

import "./nl-legal-fund-page.m.css";
import { NLLegalFundLevels } from "./nl-legal-fund-levels";

const RowWithHeadline = ({ title, showBottom, campSubscriptions }) => {
  return (
    <>
      <div styleName="heading">
        <div>{title}</div>
        <div styleName="line" />
      </div>
      <div styleName="row">
        {campSubscriptions &&
          campSubscriptions.map((subscriptions, index) => {
            return (
              <NLFundProjectCard
                showBottom={showBottom}
                subscriptions={subscriptions}
                key={index}
                redirectUrl="/sena"
              />
            );
          })}
      </div>
    </>
  );
};

RowWithHeadline.propTypes = {
  title: PT.string,
  showBottom: PT.bool,
  campSubscriptions: PT.array
};

class NLLegalFundComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptions: {}
    };
  }

  componentDidMount() {
    this.props.initAccessType();
  }

  render() {
    const img = get(this.props, ["data", "collection", "metadata", "cover-image", "cover-image-url"]);
    const campSubscriptions = get(this.props, ["campaignSubscriptions"], []);

    const currentProjects = campSubscriptions.filter(subscriptions => subscriptions.target_reached === false);
    const completedProjects = campSubscriptions.filter(subscriptions => subscriptions.target_reached === true);
    const levels = get(this.props, ["config", "nlLegalFundLevels", "levels"], []);
    console.log("levels ", levels);
    const collection = get(this.props, ["data", "collection"], {});
    const stories = getStoriesByCollection(collection) || [];
    console.log("stories ", stories, collection);
    return (
      <>
        <div styleName="container">
          <img src={img || assetify(nlSenaLogo)} alt="nlsena-logo" styleName="img-wrapper" />
          <div styleName="text-wrapper">
            <h1 styleName="title">NL Legal Fund</h1>
            <div styleName="summary">
              <p>
                Reporting truth and standing up to power can come at a cost. We adhere to the highest standards of free
                and fair journalism, yet we sometimes get legal notices and are intimidated with legal action to stop us
                from reporting the truth.
              </p>
              <p>
                While the law protects us, it can often be a long-drawn process in court, with a significant cost - time
                and money.
              </p>
              <p>
                We don’t depend on advertisers – governments or corporations. We depend on you. Our transparency is our
                strength, as are you. Help us fund our legal battles.
              </p>
            </div>
          </div>
        </div>
        {campSubscriptions.length > 0 ? (
          <div styleName="proj-container" className="full-width">
            <div className="container" styleName="proj-wrapper">
              {currentProjects.length > 0 && (
                <RowWithHeadline title="Active Cases" campSubscriptions={currentProjects} />
              )}
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <Loader color="#ec2227" />
          </div>
        )}
        <h2 styleName="story-heading">Gifts and Benefits</h2>

        <div styleName="gift-conatiner">{levels.length > 0 && <NLLegalFundLevels levels={levels} />}</div>

        {campSubscriptions.length > 0 ? (
          <div styleName="proj-container" className="full-width">
            <div className="container" styleName="proj-wrapper">
              {completedProjects.length > 0 && (
                <RowWithHeadline title="Funded Projects" showBottom={false} campSubscriptions={completedProjects} />
              )}
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <Loader color="#ec2227" />
          </div>
        )}

        {stories.length > 0 && (
          <div styleName="proj-container" className="full-width">
            <div className="container" styleName="proj-wrapper">
              <h2 styleName="story-heading">Read more</h2>
              <div styleName="subscription-collection">
                {stories.map((story, index) => {
                  return <CommonStoryCard story={story} key={index} showSection={true} />;
                })}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

NLLegalFundComponent.propTypes = {
  initAccessType: PT.func,
  config: PT.object
};

export { NLLegalFundComponent };
